
import { defineComponent, inject, reactive, ref } from 'vue';
import { ISignupService, ITellAdminPayload } from '../signupService';
import { EXTERNAL_CONNECT_URL, ISignupFormState } from '../signupFlow';
import {
    PhArrowLeft,
    PhBuildings,
    PhCheck,
    PhEnvelopeSimple,
    PhPaperPlaneTilt,
    PhUser
} from '@phosphor-icons/vue';

export default defineComponent({
    name: 'StepTellAdmin',
    components: { PhArrowLeft, PhBuildings, PhCheck, PhEnvelopeSimple, PhPaperPlaneTilt, PhUser },
    emits: ['back'],
    setup() {
        const service = inject('signupService') as ISignupService;
        // Reached in-flow from About You via use-ditto: prefill what the user
        // already typed. Deep-linked, the wizard form is empty and so are these.
        const form = inject('signupForm', null) as ISignupFormState | null;
        const submitted = ref(false);
        const submitting = ref(false);
        const showErrors = ref(false);

        const payload = reactive<ITellAdminPayload>({
            firstName: form ? form.firstName : '',
            lastName: form ? form.lastName : '',
            email: form ? form.email : '',
            orgName: form ? form.orgName : '',
            adminEmail: ''
        });

        async function handleSubmit() {
            if (!payload.firstName || !payload.lastName || !payload.email || !payload.orgName || !payload.adminEmail) {
                showErrors.value = true;
                return;
            }
            submitting.value = true;
            const result = await service.submitTellAdmin(payload);
            submitting.value = false;
            if (result.success) submitted.value = true;
        }

        return { payload, submitted, submitting, showErrors, handleSubmit, externalConnectUrl: EXTERNAL_CONNECT_URL };
    }
});
